module.exports = __webpack_public_path__ + "img/banner.9ab95cb5.png";